<template>
  <div class="left-image-wrapper">
    <div :class="['image-wrapper', { 'is-mobile': isMobile }]">
      <img :src="require(`@/assets/images/${dataSource.link}`)" />
    </div>
    <div class="content-wrapper">
      <div class="h2">
        {{ dataSource.headerText }}
      </div>
      <div v-for="(item, index) in dataSource.listArray" :key="index" v-html="item" />
    </div>
  </div>
</template>
<script>
import { isMobile } from 'mobile-device-detect';
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => [],
    },
  },
  data: () => {
    return {
      isMobile,
    };
  },
};
</script>
<style lang="scss" scoped>
.left-image-wrapper {
  display: flex;
  flex-direction: row;

  .image-wrapper {
    display: flex;
    align-items: center;

    > img {
      width: 90px;
      height: 90px;
      margin-right: 8px;
    }
  }
  .content-wrapper {
    display: flex;
    flex: 2;
    flex-direction: column;

    .h2 {
      text-transform: unset;
    }
  }
}
</style>
